//#region Libraries
import { useNavigate } from 'react-router-dom';
//#endregion
//#region Icons
import { Icon } from '@iconify/react';
//#endregion
//#region Styles
import {
    Container   
} from "./styles";
import { IS_PRODUCTION } from 'config/deploymentMode';
import ABSOLUTE_PATHS from 'routes/utils/absolutePaths';
//#endregion

const MenuButton = () => {
    const navigate = useNavigate();
    const toUsersPerRole = () => {
        if (IS_PRODUCTION) return;
        navigate(ABSOLUTE_PATHS.USERS_PER_ROLE);
    }
    return (
        <Container onClick={toUsersPerRole}>
            <Icon icon="eva:menu-fill"/>
        </Container>
    );
}

export default MenuButton;